var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_169_483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15V18.586C11.9999 18.7837 11.9413 18.977 11.8314 19.1414C11.7215 19.3058 11.5653 19.434 11.3826 19.5096C11.1999 19.5853 10.9989 19.6051 10.8049 19.5666C10.611 19.528 10.4328 19.4328 10.293 19.293L3.70697 12.707C3.5195 12.5194 3.41418 12.2651 3.41418 12C3.41418 11.7348 3.5195 11.4805 3.70697 11.293L10.293 4.70697C10.4328 4.56716 10.611 4.47196 10.8049 4.43339C10.9989 4.39482 11.1999 4.41462 11.3826 4.49029C11.5653 4.56596 11.7215 4.6941 11.8314 4.85851C11.9413 5.02292 11.9999 5.21622 12 5.41397V8.99997H15V15H12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15V9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.1f90bc5febdabfbdc62db596744a552b.svg";
export { ForwardRef as ReactComponent };